import { useCallback, useEffect, useState } from "react";
import { getTracksForReviews } from "../../../api";
import { ReviewsTrackOption } from "../../../types/requestsOutputs";

interface UseTracksForReviews {
    tracks: ReviewsTrackOption[];
    loading: boolean;
    error: string | null;
    refetch: () => Promise<void>;
}

export const useTracksForReviews = (): UseTracksForReviews => {
    const [tracks, setTracks] = useState<ReviewsTrackOption[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const load = useCallback(async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            setError("missing-token");
            return;
        }
        setLoading(true);
        setError(null);
        try {
            const res = await getTracksForReviews({ token });
            setTracks(res.tracks || []);
        } catch (e: any) {
            setError(e?.message || "unknown-error");
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        load();
    }, [load]);

    return { tracks, loading, error, refetch: load };
};
